export default {
      id: "img-icon-usage",
      viewBox: "0 0 34 26",
      url: __webpack_public_path__ + "img/icons.svg#img-icon",
      toString: function () {
        return this.url;
      }
    }